import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 37px;
  margin-bottom: 16px;
`;

export const Tab = styled.li<{ isActive?: boolean }>`
  ${({ theme, isActive }) => css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: 37px;
    text-align: center;

    ${isActive &&
    ` border-radius: 8px;
      background: ${theme.backgroundColor.bg_light_5_alpha};`}

    & > span {
      display: block;
      color: ${theme.content.content_light_1};
      ${theme.fontStyle.text.body14_bold};
    }
  `}
`;
